export default {
  title: '专业管理',
  menu: '专业管理',
  label: {
    majorChineseName: '专业中文名称',
    majorEnglishName: '专业英文名称',
    reviewStatus: '审核状态',
    edit: '编辑',
    addMajor: '新增专业',
    editMajor: '编辑专业',
    mergeTo: '合并到'
  },
  reviewStatus: {
    yes: '已审核',
    no: '未审核'
  },
  placeholder: {
    keywords: '按照专业中文名称搜索',
    pleaseStartTyping: '请开始输入'
  },
  message: {
    saveSuccess: '保存成功',
    saveFail: '保存失败'
  }
}
